import RequireAuth from 'features/auth/components/RequireAuth/RequireAuth';
import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import FullscreenProgress from 'shared/components/FullscreenProgress/FullscreenProgress';
import { ItemDetails } from './routes/ItemDetails/Loadable';
import { EstimateFeeProvider } from './routes/Cart/contexts/EstimateFeeContext/EstimateFeeContext';
import { PromoProvider } from './routes/Cart/components/PromoCode/contexts/PromoContext/PromoContext';
import { Home } from './routes/Home/Loadable';
import { Recipient } from './routes/Recipient/Loadable';
import { Search } from './routes/Search/Loadable';
import { Location } from './routes/Location/Loadable';
import { Cart } from './routes/Cart/Loadable';
import { Categories } from './routes/Categories/Loadable';
import { Store } from './routes/Store/Loadable';
import PageNotFound from 'shared/components/PageNotFound/PageNotFound';
import ItemSearchInStoreFormContext from './routes/Store/components/ItemSearchInStoreForm/ItemSearchInStoreFormContext';
import Tag from './routes/Tag/Tag';

const Main = () => {
  return (
    <Suspense fallback={<FullscreenProgress />}>
      <Routes>
        <Route path='/' element={<Home />} />

        <Route path='recipient' element={<Recipient />} />
        <Route path='location' element={<Location />} />

        <Route path='search' element={<Search />} />

        <Route
          path='cart'
          element={
            <RequireAuth>
              <PromoProvider>
                <EstimateFeeProvider>
                  <Cart />
                </EstimateFeeProvider>
              </PromoProvider>
            </RequireAuth>
          }
        />

        <Route path=':categorySlug' element={<Categories />} />
        <Route path='store'>
          <Route
            path=':storeId'
            element={
              <ItemSearchInStoreFormContext>
                <Store />
              </ItemSearchInStoreFormContext>
            }
          />
          <Route index element={<PageNotFound />} />
        </Route>
        <Route path='t'>
          <Route path=':tagSlug' element={<Tag />} />
          <Route index element={<PageNotFound />} />
        </Route>

        {/* <Route path=':itemSlug' element={<ItemDetails />} /> */}
        <Route path=':categorySlug/:itemSlug' element={<ItemDetails />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default Main;
